import React from "react";
import EventCardPlaceholder from "../../EventCardPlaceholder/EventCardPlaceholder";
import { Skeleton } from "../../Skeleton/Skeleton";

export const SeriesDetailPageLoading = () => (
  <>
    <div className="tbk-flex tbk-flex-col tbk-items-center tbk-justify-center tbk-pb-4 lg:tbk-pb-4 lg:tbk-pt-4">
      <div className="tbk-container tbk-px-2 lg:tbk-px-8">
        <div className="tbk-grid tbk-gap-4 lg:tbk-grid-cols-2 lg:tbk-gap-8">
          <div className="tbk--order-1_ lg:tbk-order-1_ tbk-relative tbk--ml-2 tbk--mr-2 tbk-overflow-hidden tbk-bg-home-our-coaches-mobile lg:tbk-ml-0 lg:tbk-mr-0 lg:tbk-h-auto lg:tbk-bg-none">
            <div className="tbk-relative">
              <Skeleton className="tbk-h-64 tbk-w-full tbk-bg-blue-grey-light tbk-object-cover lg:tbk-h-80 lg:tbk-rounded-2xl" />
            </div>
          </div>
          <div className="7 tbk-mb-2 lg:tbk-mb-0">
            <div className="tbk-mb-4_ tbk-relative tbk-items-center">
              <Skeleton className="tbk-text-h3-subtitle tbk-w-20 tbk-mb-1 tbk-h-6 tbk-bg-blue-grey-light" />
              <div className="tbk-min-w-0 tbk-grow tbk-overflow-hidden">
                <Skeleton className="tbk-text-title-bold lg:tbk-text-h2-black tbk-mb-2 tbk-h-8 tbk-w-3/4 tbk-bg-blue-grey-light" />
                <Skeleton className="tbk-text-main tbk-mb-2 tbk-h-5 tbk-w-1/2 tbk-bg-blue-grey-light" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="tbk-container tbk-mx-auto tbk-px-2 tbk-pb-24 lg:tbk-px-8">
      <div>
        <h3 className="tbk-relative tbk-mb-3 tbk-flex tbk-items-center tbk-justify-center tbk-pt-4 lg:tbk-mb-3">
          <div className="tbk-border-t tbk-border-basic-white tbk-border-blue-grey-light"></div>
          <Skeleton className="tbk-bg-grey-light_ tbk-text-h3-subtitle lg:tbk-text-title-bold tbk-h-6 tbk-w-32 tbk-text-left tbk-text-center tbk-text-blue-grey lg:!tbk-font-semibold" />
          <div className="tbk-mx-2 tbk-flex-1 tbk-border-t tbk-border-basic-white tbk-border-blue-grey-light"></div>
        </h3>
        <div className="tbk-mb-4 tbk-grid tbk-gap-2 md:tbk-grid-cols-2 lg:tbk-grid-cols-3">
          <EventCardPlaceholder />
          <EventCardPlaceholder />
          <EventCardPlaceholder />
          <EventCardPlaceholder />
        </div>
      </div>
    </div>
  </>
);
